import { add } from 'date-fns'
import classnames from 'classnames'
import { Button, ComponentTrackingType } from '@homebotapp/hb-react-component-catalog'
import { getMonthLabels } from '../RangeDatePicker/util'

import styles from './MonthPicker.module.scss'

export interface MonthPickerProps {
  startMonth: Date
  className: string
  isSelected: (month: Date) => boolean
  onClick: (monthIndex: number) => void
  tracking: ComponentTrackingType
}

export const MonthPicker = ({ onClick, className, startMonth, isSelected, tracking }: MonthPickerProps) => {
  return (
    <div data-qa='MonthPicker' className={classnames(styles.root, className)}>
      {getMonthLabels(startMonth, true).map((month, i) => (
        <Button
          margin={1}
          key={`${month}`}
          onClick={() => onClick(i)}
          flex={['1 0 39%', '1 0 29%']}
          data-qa={`MonthPicker-button-${month}`}
          isActive={isSelected(add(startMonth, { months: i }))}
          tracking={{
            ...tracking,
            descriptor: month
          }}
        >
          {month}
        </Button>
      ))}
    </div>
  )
}
